import { DollarSign, Scale, ShieldCheck, Workflow } from 'lucide-react';
import { SubHubLayout } from './SubHubLayout';

/**
 * `/admin/parametros/workflows` — ONDA-CA2, item ADM-055 do laudo de comparação QA.
 *
 * Os quatro destinos existem e são link. "Alçadas por valor" e "Motor de
 * alçadas" nasceram inertes com selo "Em construção"; o motor já havia sido
 * construído em `/admin/parametros/workflows/alcadas-genericas` e o card seguia
 * inerte por engano, e as alçadas por valor entraram na ONDA-T3.
 */
export function WorkflowsAprovacoesHub() {
  return (
    <SubHubLayout
      titulo="Workflows & aprovações"
      descricao="Tipos de solicitação, alçadas por valor e parâmetros DTEG."
      voltarPara="/admin"
      itens={[
        {
          titulo: 'Tipos de solicitação',
          descricao: 'Catálogo dinâmico de solicitações do portal (trocas, inclusões).',
          icone: Workflow,
          para: '/admin/tipos-solicitacao',
        },
        {
          titulo: 'Alçadas por valor (financeiro)',
          descricao: 'Quem aprova cada faixa de multa, cobrança e medição.',
          icone: DollarSign,
          para: '/admin/parametros/workflows/alcadas',
        },
        {
          titulo: 'Motor de alçadas (genérico)',
          descricao:
            'Regras de alçada para defesa intempestiva, glosa retroativa e substituição em lote.',
          icone: Scale,
          para: '/admin/parametros/workflows/alcadas-genericas',
        },
        {
          titulo: 'Parâmetros de aprovação',
          descricao: 'Regras de validação DTEG por tipo de ação.',
          icone: ShieldCheck,
          para: '/admin/parametros/aprovacoes',
        },
      ]}
    />
  );
}

export default WorkflowsAprovacoesHub;
